import { useModel } from 'umi';
import { useTranslation } from 'react-i18next';
import { BlueDesignProvider, Spacing } from '@bluevision/components';

import HelpCenter from './HelpCenter';

import Feedback from './Feedback';
import AdvertisementTip from './AdvertisementTip';
import NewFeatureNotification from './NewFeatureNotification';
import styles from './index.less';

const HeaderContent: React.FC = () => {
  const { initialState } = useModel('@@initialState');
  const { i18n } = useTranslation();

  /** 是否配置了用户反馈能力的灰度 */
  const isOpenCollectOpinions = initialState?.currentUser?.grayscale.collectOpinions;

  return (
    <BlueDesignProvider language={i18n.language}>
      <Spacing className={styles['header-content-wrapper']}>
        {initialState?.currentUser?.grayscale?.roiBest && <AdvertisementTip />}
        {/* 用户反馈 */}
        {isOpenCollectOpinions && <Feedback />}
        {/* 新功能通知 */}
        {initialState?.currentUser && initialState?.currentUser?.walletInfo?.reservedAmount && (
          <NewFeatureNotification />
        )}
        <HelpCenter />
      </Spacing>
    </BlueDesignProvider>
  );
};

export default HeaderContent;
